import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cf-money",
  "use": "icon-cf-money-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-cf-money\">\n<path d=\"M16 9.5V9.5C16 8.11929 14.8807 7 13.5 7H10.5C9.11929 7 8 8.11929 8 9.5V9.5C8 10.8807 9.11929 12 10.5 12H13.5C14.8807 12 16 13.1193 16 14.5V14.5C16 15.8807 14.8807 17 13.5 17H10.5C9.11929 17 8 15.8807 8 14.5V14.5\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" />\n<path d=\"M12 19L12 5\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol